module.exports = __webpack_public_path__ + "img/bg2.98048dc5.png";